import { UPDATE_SEARCHTDATA_HOPDONGCHODUYET } from "../../actions/DanhSachHopDongChoDuyet/actionTypes";

const initialState = {
  customerName: "",
  status: -1,
  pageIndex: 1,
  pageSize: 25,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchHopDongChoDuyet = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_HOPDONGCHODUYET:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchHopDongChoDuyet;
